module.exports = __webpack_public_path__ + "static/media/listing-page-coonoor.7b96bf79.jpg";